import React from "react";
import sectionImg from "../../images/Section 07.webp";
import "../../styles/main.scss";

const miniPillars = [
  { icon: "✨", label: "Simple Weekly\nClarity", tone: "orange" },
  { icon: "👥", label: "No Extra\nWorkload", tone: "blue" },
  { icon: "🎯", label: "Practical\nDirection", tone: "green" },
  { icon: "🔒", label: "Private &\nSecure", tone: "purple" },
];

const trustCards = [
  {
    num: "1.",
    icon: "📊",
    tone: "orange",
    mark: "✓",
    title: "Simple weekly clarity instead of confusing reports.",
    desc:
      "You receive weekly salon clarity in a format that is visual, simple, and easy to understand. No long reports, no technical overload, and no confusing breakdowns — just the information that helps you see your salon more clearly.",
  },
  {
    num: "2.",
    icon: "👥",
    tone: "blue",
    mark: "✓",
    title: "No extra workload for you or your team.",
    desc:
      "You do not need new software, new habits, or a complicated process. Munafa Engine works with simple numbers from your salon and turns them into structured weekly clarity — without adding unnecessary burden to your existing way of working.",
  },
  {
    num: "3.",
    icon: "🎯",
    tone: "green",
    mark: "✓",
    title: "Practical weekly direction, not generic advice.",
    desc:
      "Each week, you receive clear weekly direction based on your real salon numbers. That means better visibility into what needs attention, what needs improvement, and what should be watched more carefully — without guesswork and without vague suggestions.",
  },
  {
    num: "4.",
    icon: "🔒",
    tone: "purple",
    mark: "✓",
    title: "Your salon data stays private, secure, and fully confidential.",
    desc:
      "Your information is handled with care, respect, and confidentiality. The purpose is to help you see your salon more clearly and make better weekly decisions — while your business data stays protected and private.",
  },
];

const Section07 = () => {
  return (
    <section className="section-07">
      <div className="section-07__inner">
        <div className="section-07__top">
          <div className="section-07__text">
            <h2 className="section-07__title">
              Why Salon Owners Find Munafa Engine Easy to Trust
            </h2>

            <p className="section-07__intro">
              Trust is earned through clarity, simplicity, and consistency.
              <br />
              Here is why salon owners rely on Munafa Engine every week.
            </p>

            <div className="section-07__pillars">
              {miniPillars.map((p) => (
                <div
                  className={`section-07__pillar section-07__pillar--${p.tone}`}
                  key={p.label}
                >
                  <div className="section-07__pillar-icon">{p.icon}</div>

                  <div className="section-07__pillar-label">
                    {p.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="section-07__hero">
            <img
              src={sectionImg}
              alt="Salon owner reviewing Munafa Engine weekly clarity dashboard"
              className="section-07__hero-image"
             loading="lazy" decoding="async"/>

            <div className="section-07__hero-shadow" />

            <div className="section-07__float section-07__float--summary">
              <div className="section-07__float-title">
                Weekly Summary
              </div>

              <div
                className="section-07__float-bars"
                aria-hidden="true"
              >
                <span style={{ height: "30%" }} />
                <span style={{ height: "55%" }} />
                <span style={{ height: "42%" }} />
                <span style={{ height: "70%" }} />
                <span style={{ height: "60%" }} />
                <span
                  style={{
                    height: "85%",
                    background: "#ffad21",
                  }}
                />
                <span
                  style={{
                    height: "92%",
                    background: "#ffad21",
                  }}
                />
              </div>
            </div>

            <div className="section-07__float section-07__float--profit">
              <div className="section-07__float-title">
                Profit Snapshot
              </div>

              <div className="section-07__float-row">
                <div
                  className="section-07__donut"
                  aria-hidden="true"
                />

                <div>
                  <div className="section-07__float-amount">
                    ₹1,84,500
                  </div>

                  <div className="section-07__float-sub">
                    Total Revenue
                  </div>
                </div>
              </div>
            </div>

            <div className="section-07__float section-07__float--secure">
              <div className="section-07__float-row">
                <div className="section-07__lock">🔒</div>

                <div>
                  <div className="section-07__float-title">
                    Private &amp; Secure
                  </div>

                  <div className="section-07__float-sub">
                    Your data stays safe,
                    <br />
                    confidential &amp; private.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-07__cards">
          {trustCards.map((card) => (
            <article
              className={`section-07__card section-07__card--${card.tone}`}
              key={card.num}
            >
              <div className="section-07__card-top">
                <div className="section-07__card-icon">
                  {card.icon}
                </div>

                <div className="section-07__card-mark">
                  {card.mark}
                </div>
              </div>

              <h3 className="section-07__card-title">
                <span className="section-07__card-num">
                  {card.num}
                </span>{" "}
                {card.title}
              </h3>

              <p className="section-07__card-desc">
                {card.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Section07;